// Única URL del backend para toda la app. Antes cada pantalla la armaba con una variable distinta
// (REACT_APP_API_URL, REACT_APP_AUTH_SERVICE, REACT_APP_FAST_FOOD_SERVICE...) y algunas caían por defecto
// en el puerto 8002 del antiguo clinic-service. En docker-compose todas apuntan al mismo servidor.
export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_AUTH_SERVICE ||
    process.env.REACT_APP_FAST_FOOD_SERVICE ||
    'http://localhost:8000';
